import { useDispatch, useSelector } from "react-redux";

import { useEffect, useState } from "react";
import $ from "jquery";
import Swal from "sweetalert2";
import { GetAllPR_Nationality } from "../../Redux/Reducers/ReportStage/NationalityDropDown";
import { GetAllPR_TypeOfActivity } from "../../Redux/Reducers/ReportStage/TypeOfActivityDropDown";
import { GetAllPR_AgeGroup } from "../../Redux/Reducers/ReportStage/AgeGroupDropDown";
import { GetAllPR_City } from "../../Redux/Reducers/ReportStage/CityDropdown";
import { setRefreshTable } from "../../Redux/Reducers/VariousVariables";
import {
  AddEventsActivitiesData,
  GetOneEventsActivities,
  restValidateEventsActivities,
  UpdateEventsActivitiesData,
  ValidateEventsActivities,
} from "../../Redux/Reducers/ReportStage/EventsActivities";
import InputAHSF from "../../Components/InputAHSF";
import AllDropDownsAHSF from "../../Components/AllDropDownsAHSF";
import DateInput from "../../Components/DateInput";
import ButtonAHSF from "../../Components/ButtonAHSF";
import LoaderAHSF from "../../Components/LoaderAHSF";
import { useParams } from "react-router-dom";
import { decryptToken } from "../../Services/Account/EncryptionParams";

const AddEditEventsActivities = (props) => {
  const dispatch = useDispatch();
  let { stageGuid } = useParams();

  stageGuid = decryptToken(stageGuid);
  const state = useSelector((state) => {
    return {
      //////////////////////////////////////////////////////////

      OneEventsActivities: state.EventsActivities.OneEventsActivities,
      UpdateEventsActivities: state.EventsActivities.UpdateEventsActivities,
      EventsActivitiesValidate: state.EventsActivities.EventsActivitiesValidate,
      loadingOneEventsActivities:
        state.EventsActivities.loadingOneEventsActivities,

      PR_TypeOfActivityDropDown:
        state.PR_TypeOfActivityDropDown.PR_TypeOfActivityDropDown,

      PR_NationalityDropDown:
        state.PR_NationalityDropDown.PR_NationalityDropDown,

      PR_AgeGroupDropDown: state.PR_AgeGroupDropDown.PR_AgeGroupDropDown,

      PR_CityDropDown: state.PR_CityDropDown.PR_CityDropDown,
    };
  });

  console.log(state.OneEventsActivities, "test");

  const [EventsActivitiesList, setEventsActivitiesList] = useState({
    pR_EventsActivitiesGUID: state.OneEventsActivities?.pR_EventsActivitiesGUID,
    activityName: state.OneEventsActivities?.activityName,
    pR_NationalityId: state.OneEventsActivities?.pR_NationalityId,
    pR_TypeOfActivityId: state.OneEventsActivities?.pR_TypeOfActivityId,
    durationDays: state.OneEventsActivities?.durationDays,
    activityStartDate: state.OneEventsActivities?.activityStartDate,
    activityEndDate: state.OneEventsActivities?.activityEndDate,
    pR_AgeGroupID: state.OneEventsActivities?.pR_AgeGroupID,
    pR_CityId: state.OneEventsActivities?.pR_CityId,
    numberOfFemale: state.OneEventsActivities?.numberOfFemale,
    numberOfMale: state.OneEventsActivities?.numberOfMale,
    total: state.OneEventsActivities?.total,
    pR_ReportsStagesGuid: stageGuid,
  });

  // Effect to fetch TypeOfJobOpportunity data

  // Function to update an existing project management team member

  useEffect(() => {
    dispatch(GetAllPR_TypeOfActivity());
  }, []);

  useEffect(() => {
    dispatch(GetAllPR_Nationality());
  }, []);

  useEffect(() => {
    dispatch(GetAllPR_AgeGroup());
  }, []);
  useEffect(() => {
    dispatch(GetAllPR_City());
  }, []);

  const AddEventsActivities = async () => {
    const validationList = await dispatch(
      ValidateEventsActivities({
        activityName: EventsActivitiesList.activityName,
        pR_NationalityId: EventsActivitiesList.pR_NationalityId,
        pR_TypeOfActivityId: EventsActivitiesList.pR_TypeOfActivityId,
        durationDays:
          EventsActivitiesList.durationDays == ""
            ? null
            : EventsActivitiesList.durationDays,
        numberOfFemale:
          EventsActivitiesList.numberOfFemale == ""
            ? null
            : EventsActivitiesList.numberOfFemale,
        numberOfMale:
          EventsActivitiesList.numberOfMale == ""
            ? null
            : EventsActivitiesList.numberOfMale,
        activityStartDate: EventsActivitiesList.activityStartDate,
        activityEndDate: EventsActivitiesList.activityEndDate,
        pR_AgeGroupID: EventsActivitiesList.pR_AgeGroupID,
        pR_CityId: EventsActivitiesList.pR_CityId,
      })
    );

    if (validationList.payload.length === 0) {
      await dispatch(
        AddEventsActivitiesData({
          activityName: EventsActivitiesList.activityName,
          pR_NationalityId: EventsActivitiesList.pR_NationalityId,
          pR_TypeOfActivityId: EventsActivitiesList.pR_TypeOfActivityId,
          activityStartDate: EventsActivitiesList.activityStartDate,
          numberOfFemale: EventsActivitiesList.numberOfFemale,
          numberOfMale: EventsActivitiesList.numberOfMale,
          activityEndDate: EventsActivitiesList.activityEndDate,
          pR_AgeGroupID: EventsActivitiesList.pR_AgeGroupID,
          durationDays: EventsActivitiesList.durationDays,
          pR_CityId: EventsActivitiesList.pR_CityId,
          pR_ReportsStagesGuid: EventsActivitiesList.pR_ReportsStagesGuid,
          total: EventsActivitiesList.total,
        })
      );
      $(".close-btn").trigger("click");
      Swal.fire({
        position: "center",
        icon: "success",
        title: "تم اضافة المعلومات بنجاح",
        showConfirmButton: false,
        timer: 1500,
        // width: "500px",
      });
      dispatch(setRefreshTable());
    }
  };

  const UpdateEventsActivities = async () => {
    const validationList = await dispatch(
      ValidateEventsActivities({
        activityName: EventsActivitiesList.activityName,
        pR_NationalityId: EventsActivitiesList.pR_NationalityId,
        pR_TypeOfActivityId: EventsActivitiesList.pR_TypeOfActivityId,
        durationDays:
          EventsActivitiesList.durationDays == ""
            ? null
            : EventsActivitiesList.durationDays,
        numberOfFemale:
          EventsActivitiesList.numberOfFemale == ""
            ? null
            : EventsActivitiesList.numberOfFemale,
        numberOfMale:
          EventsActivitiesList.numberOfMale == ""
            ? null
            : EventsActivitiesList.numberOfMale,
        activityStartDate: EventsActivitiesList.activityStartDate,
        activityEndDate: EventsActivitiesList.activityEndDate,
        pR_AgeGroupID: EventsActivitiesList.pR_AgeGroupID,
        pR_CityId: EventsActivitiesList.pR_CityId,
      })
    );
    // If no validation errors, update team member
    if (validationList.payload.length === 0) {
      await dispatch(
        UpdateEventsActivitiesData({
          pR_EventsActivitiesGUID: EventsActivitiesList.pR_EventsActivitiesGUID,
          activityName: EventsActivitiesList.activityName,
          pR_NationalityId: EventsActivitiesList.pR_NationalityId,
          pR_TypeOfActivityId: EventsActivitiesList.pR_TypeOfActivityId,
          activityStartDate: EventsActivitiesList.activityStartDate,
          numberOfFemale: EventsActivitiesList.numberOfFemale,
          numberOfMale: EventsActivitiesList.numberOfMale,
          activityEndDate: EventsActivitiesList.activityEndDate,
          pR_AgeGroupID: EventsActivitiesList.pR_AgeGroupID,
          durationDays: EventsActivitiesList.durationDays,
          pR_CityId: EventsActivitiesList.pR_CityId,
          pR_ReportsStagesGuid: EventsActivitiesList.pR_ReportsStagesGuid,
          total: EventsActivitiesList.total,
        })
      );
      $(".close-btn").trigger("click");
      Swal.fire({
        position: "center",
        icon: "success",
        title: "تم تعديل المعلومات بنجاح",
        showConfirmButton: false,
        timer: 1500,
        // width: "500px",
      });
      dispatch(setRefreshTable());
    }
  };
  useEffect(() => {
    dispatch(restValidateEventsActivities());
  }, []);
  useEffect(() => {
    if (props != null) {
      dispatch(GetOneEventsActivities(props.pR_EventsActivitiesGUID));
    }
  }, [props.pR_EventsActivitiesGUID]);
  useEffect(() => {
    if (!state.loadingOneEventsActivities && Object.keys(props).length != 0) {
      setEventsActivitiesList({
        ...state.OneEventsActivities,
      });
    } else {
      setEventsActivitiesList({
        activityName: null,
        pR_NationalityId: null,
        pR_TypeOfActivityId: null,
        activityStartDate: null,
        activityEndDate: null,
        pR_AgeGroupID: null,
        pR_CityId: null,
        durationDays: null,
        numberOfFemale: null,
        numberOfMale: null,
        total: null,
        pR_ReportsStagesGuid: EventsActivitiesList.pR_ReportsStagesGuid,
      });
    }
  }, [state.OneEventsActivities]);

  //   const shouldDisableFields = !(

  //     (
  //       state.ActiveRound == state.ApplicationInformation?.aI_RoundYearId &&
  //       state.ApplicationInformation?.aI_ApplicationStatus?.canEdite &&
  //       window.location.href.includes("manager") == false
  //     )
  //   );
  //to render html after loading ends
  return (
    <>
      {!state.loadingOneEventsActivities ? (
        <>
          <div className="AddEdite">
            <InputAHSF
              fieldsName="ActivityName"
              show={true}
              disabled={props.shouldDisableFields}
              onChange={(e) => {
                setEventsActivitiesList({
                  ...EventsActivitiesList,
                  activityName: e.target.value,
                });
              }}
              defaultValue={
                state.OneEventsActivities?.activityName
                // OpportunitiesObtainedList?.entityProvidingOpportunity
              }
              showValidationMessage={
                state.EventsActivitiesValidate
                  ? state.EventsActivitiesValidate.includes("ActivityName")
                  : false
              }
              validationMessage="يرجى تعبئة هذا الحقل"
            />
            {/* <AllDropDownsAHSF
              fieldsName="PR_Nationality"
              show={true}
              // disabled={shouldDisableFields}
              arrayOoptionList={state.PR_NationalityDropDown}
              KeyText={"nationalityAr"}
              KeyValue={"pR_NationalityId"}
              dropdownType={"normal"}
              onChange={(e) => {
                setEventsActivitiesNextFlowList({
                  ...EventsActivitiesNextFlowList,
                  pR_NationalityId: Number(e.target.value),
                });
              }}
              defaultValue={EventsActivitiesNextFlowList.pR_NationalityId}
              showValidationMessage={
                state.EventsActivitiesNextFlowValidate
                  ? state.EventsActivitiesNextFlowValidate.includes(
                      "PR_Nationality"
                    )
                  : false
              }
              validationMessage="يرجى تعبئة هذا الحقل"
            />
            <AllDropDownsAHSF
              fieldsName="PR_CityId"
              show={true}
              // disabled={shouldDisableFields}
              arrayOoptionList={state.PR_CityDropDown}
              KeyText={"cityNAmeAr"}
              KeyValue={"pR_CityId"}
              dropdownType={"normal"}
              onChange={(e) => {
                setEventsActivitiesNextFlowList({
                  ...EventsActivitiesNextFlowList,
                  pR_CityId: Number(e.target.value),
                });
              }}
              defaultValue={EventsActivitiesNextFlowList.pR_CityId}
              showValidationMessage={
                state.EventsActivitiesNextFlowValidate
                  ? state.EventsActivitiesNextFlowValidate.includes("PR_CityId")
                  : false
              }
              validationMessage="يرجى تعبئة هذا الحقل"
            /> */}
            <AllDropDownsAHSF
              fieldsName="PR_Nationality"
              show={true}
              arrayOoptionList={state.PR_NationalityDropDown}
              disabled={props.shouldDisableFields}
              KeyText={"nationalityAr"}
              KeyValue={"pR_NationalityId"}
              dropdownType={"normal"}
              onChange={(e) => {
                const selectedNationalityId = Number(e.target.value);
                setEventsActivitiesList({
                  ...EventsActivitiesList,
                  pR_NationalityId: selectedNationalityId,
                  // Reset the city if nationality changes
                  pR_CityId: null,
                });
              }}
              defaultValue={EventsActivitiesList.pR_NationalityId}
              showValidationMessage={
                state.EventsActivitiesValidate
                  ? state.EventsActivitiesValidate.includes("PR_Nationality")
                  : false
              }
              validationMessage="يرجى تعبئة هذا الحقل"
            />

            <AllDropDownsAHSF
              fieldsName="PR_CityId"
              show={true}
              disabled={props.shouldDisableFields}
              arrayOoptionList={
                EventsActivitiesList.pR_NationalityId
                  ? state.PR_CityDropDown.filter(
                      (city) =>
                        city.pR_NationalityId ===
                        EventsActivitiesList.pR_NationalityId
                    )
                  : [] // Empty array when no nationality is selected
              }
              KeyText={"cityNAmeAr"}
              KeyValue={"pR_CityId"}
              dropdownType={"normal"}
              onChange={(e) => {
                setEventsActivitiesList({
                  ...EventsActivitiesList,
                  pR_CityId: Number(e.target.value),
                });
              }}
              defaultValue={EventsActivitiesList.pR_CityId}
              showValidationMessage={
                state.EventsActivitiesValidate
                  ? state.EventsActivitiesValidate.includes("PR_CityId")
                  : false
              }
              validationMessage="يرجى تعبئة هذا الحقل"
            />

            <AllDropDownsAHSF
              fieldsName="PR_TypeOfActivityId"
              show={true}
              disabled={props.shouldDisableFields}
              arrayOoptionList={state.PR_TypeOfActivityDropDown}
              KeyText={"typeOfActivityNAme"}
              KeyValue={"pR_TypeOfActivityId"}
              dropdownType={"normal"}
              onChange={(e) => {
                setEventsActivitiesList({
                  ...EventsActivitiesList,
                  pR_TypeOfActivityId: Number(e.target.value),
                });
              }}
              defaultValue={EventsActivitiesList.pR_TypeOfActivityId}
              showValidationMessage={
                state.EventsActivitiesValidate
                  ? state.EventsActivitiesValidate.includes(
                      "PR_TypeOfActivityId"
                    )
                  : false
              }
              validationMessage="يرجى تعبئة هذا الحقل"
            />

            <InputAHSF
              fieldsName="DurationDays"
              type={"number"}
              show={true}
              disabled={props.shouldDisableFields}
              onChange={(e) => {
                setEventsActivitiesList({
                  ...EventsActivitiesList,
                  durationDays: e.target.value,
                });
              }}
              defaultValue={
                state.OneEventsActivities?.durationDays
                // OpportunitiesObtainedList?.entityProvidingOpportunity
              }
              showValidationMessage={
                state.EventsActivitiesValidate
                  ? state.EventsActivitiesValidate.includes("DurationDays")
                  : false
              }
              validationMessage="يرجى تعبئة هذا الحقل"
            />

            <DateInput
              fieldsName="ActivityStartDate"
              list=""
              date={state.OneEventsActivities?.activityStartDate}
              onChange={(e) => {
                setEventsActivitiesList({
                  ...EventsActivitiesList,
                  activityStartDate: e, // التحديث هنا
                });
              }}
              disabled={props.shouldDisableFields}
              showValidationMessage={
                state.EventsActivitiesValidate
                  ? state.EventsActivitiesValidate.includes("ActivityStartDate")
                  : false
              }
              validationMessage="يرجى تعبئة هذا الحقل"
            />
            <DateInput
              fieldsName="ActivityEndDate"
              list=""
              date={state.OneEventsActivities?.activityEndDate}
              onChange={(e) => {
                setEventsActivitiesList({
                  ...EventsActivitiesList,
                  activityEndDate: e, // التحديث هنا
                });
              }}
              disabled={props.shouldDisableFields}
              showValidationMessage={
                state.EventsActivitiesValidate
                  ? state.EventsActivitiesValidate.includes("ActivityEndDate")
                  : false
              }
              validationMessage="يرجى تعبئة هذا الحقل"
            />

            <AllDropDownsAHSF
              fieldsName="PR_AgeGroup"
              show={true}
              disabled={props.shouldDisableFields}
              arrayOoptionList={state.PR_AgeGroupDropDown}
              KeyText={"ageGroupName"}
              KeyValue={"pR_AgeGroupID"}
              dropdownType={"normal"}
              onChange={(e) => {
                setEventsActivitiesList({
                  ...EventsActivitiesList,
                  pR_AgeGroupID: Number(e.target.value),
                });
              }}
              defaultValue={EventsActivitiesList.pR_AgeGroupID}
              showValidationMessage={
                state.EventsActivitiesValidate
                  ? state.EventsActivitiesValidate.includes("PR_AgeGroup")
                  : false
              }
              validationMessage="يرجى تعبئة هذا الحقل"
            />
            <InputAHSF
              fieldsName="NumberOfFemale"
              show={true}
              disabled={props.shouldDisableFields}
              onChange={(e) => {
                setEventsActivitiesList({
                  ...EventsActivitiesList,
                  numberOfFemale: Number(e.target.value),
                });
              }}
              defaultValue={
                state.OneEventsActivities?.numberOfFemale
                // OpportunitiesObtainedList?.entityProvidingOpportunity
              }
              showValidationMessage={
                state.EventsActivitiesValidate
                  ? state.EventsActivitiesValidate.includes("NumberOfFemale")
                  : false
              }
              validationMessage="يرجى تعبئة هذا الحقل"
            />
            <InputAHSF
              fieldsName="NumberOfMale"
              show={true}
              disabled={props.shouldDisableFields}
              onChange={(e) => {
                setEventsActivitiesList({
                  ...EventsActivitiesList,
                  numberOfMale: Number(e.target.value),
                });
              }}
              defaultValue={
                state.OneEventsActivities?.numberOfMale
                // OpportunitiesObtainedList?.entityProvidingOpportunity
              }
              showValidationMessage={
                state.EventsActivitiesValidate
                  ? state.EventsActivitiesValidate.includes("NumberOfMale")
                  : false
              }
              validationMessage="يرجى تعبئة هذا الحقل"
            />
            <InputAHSF
              fieldsName="Total"
              disabled={"true"}
              show={true}
              onChange={(e) => {
                setEventsActivitiesList({
                  ...EventsActivitiesList,
                  total: e.target.value,
                });
              }}
              defaultValue={state.OneEventsActivities?.total}
            />
            {!props.shouldDisableFields ? (
              <div className="containersButton">
                <div>
                  <ButtonAHSF
                    type={"submitter"}
                    onClick={() => {
                      props.canEdit == "edit"
                        ? UpdateEventsActivities()
                        : AddEventsActivities();
                    }}
                    disabled={false}
                    title={Object.keys(props).length == 0 ? "إضافة" : "تعديل"}
                    text={Object.keys(props).length == 0 ? "إضافة" : "تعديل"}
                    show={true}
                  />
                </div>
              </div>
            ) : (
              ""
            )}
          </div>
        </>
      ) : (
        ""
      )}
      <LoaderAHSF show={state.loadingOneEventsActivities} />
    </>
  );
};

export default AddEditEventsActivities;
